var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('os-sheet',{staticClass:"minimal-critical-height"},[_c('os-target-profile-form',{attrs:{"title":"Target profile"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }